export const CONFIG_TOKEN = 'evnConfigToken';

